import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.less';

export default function LoadingSpinner(_ref) {
  var width = _ref.width;

  return React.createElement(
    'div',
    { className: styles.loaderContainer },
    React.createElement('div', { className: styles.loader, style: { width: width + 'px', height: width + 'px' } })
  );
}

LoadingSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.number
} : {};

LoadingSpinner.defaultProps = {
  width: 50
};